import { chunk } from "lodash";
import React from "react";
import styled from "styled-components";
import { GroupMemberRole } from "@domain/group/group";
import { GroupMember } from "@domain/group/groupMember";
import { Profile } from "@domain/user/profile";
import { useIsMobile } from "@utils/hooks";
import { mobile } from "@ui/styles/utils";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { row, Spacer, stack } from "@ui/components/layout";
import { UserView } from "@ui/components/profile/userView";
import { MemberActions } from "./memberActions";
// import { KebabMenu } from "../../menus/kebabMenu";

interface DetailedMemberListProps extends React.HTMLAttributes<HTMLDivElement> {
	loading: boolean;
	onEndReached: () => void;
	members: Profile[];
	deleteMember?: (id: string, role?: GroupMemberRole) => void;
	acceptMember?: (member: GroupMember) => void;
	protectedMember?: string;
	canRemoveItself?: boolean;
}
export const DetailedMemberList: React.FC<DetailedMemberListProps> = ({
	loading,
	onEndReached,
	members,
	deleteMember,
	acceptMember,
	protectedMember,
	canRemoveItself,
	...htmlProps
}) => {
	const isMobile = useIsMobile();
	const displayedMembers = chunk(members, isMobile ? 1 : 2);

	return (
		<div {...htmlProps}>
			<InfiniteScroll loading={loading} onEndReached={onEndReached}>
				<Content>
					{displayedMembers.map((row, i) => (
						<Row key={i}>
							{row.map((member) => (
								<Item key={member.id} unconfirmed={((member as GroupMember).status ?? "VALIDATED") !== "VALIDATED"}>
									<UserView
										pictureSize={"L"}
										gap={16}
										user={member}
										alignStart
										showDescription
										renderBottomAccessory={() => (
											<MemberActions
												canRemoveItself={canRemoveItself}
												member={member as GroupMember}
												deleteMember={deleteMember}
												acceptMember={acceptMember}
												protectedMember={protectedMember}
											/>
										)}
									/>
									{/* <KebabMenu>
										<MemberActions
											mode="stack"
											canRemoveItself={canRemoveItself}
											member={member as GroupMember}
											deleteMember={deleteMember}
											acceptMember={acceptMember}
											protectedMember={protectedMember}
										/>
									</KebabMenu> */}
								</Item>
							))}
							{row.length < 2 && !isMobile && <Spacer />}
						</Row>
					))}
				</Content>
			</InfiniteScroll>
		</div>
	);
};

const Content = styled.div`
	${stack(0, "flex-start", "stretch")};
	> button {
		margin: auto;
	}
`;

const Row = styled.div`
	${row(40)};
	padding: 25px 40px;

	@media ${mobile} {
		padding: 20px;
	}

	// &:not(:last-child)  {
	// 	border-bottom: 1px solid ${({ theme }) => theme.colors.lightergray};
	// }

	> * {
		flex: 1;
		flex-shrink: 0;
		width: 50%;
	}
`;

const Item = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "unconfirmed",
})<{ unconfirmed: boolean }>`
	${row(10)};
	.primaryName {
		${({ theme }) => theme.textStyles.desktopSubtitle};
	}
	.profile-picture,
	.primaryName {
		${({ unconfirmed }) => unconfirmed && "opacity: 0.2"};
	}
`;
